// extracted by mini-css-extract-plugin
export default {"file-name-overflow":"ConversationHeader-module__file-name-overflow--Ymb0e"};